import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';
import { CITIES, SHARED } from './utils/product';

const RegioesAtendidas = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-16 lg:py-24">
          <div className="max-w-2xl">
            <span className="badge-brand mb-5">Cobertura</span>
            <h1 className="font-display text-display-xl text-ink-900">
              Grande Goiânia
            </h1>
            <p className="mt-5 text-xl text-ink-500 leading-relaxed">
              Os três planos operam na Região Metropolitana, em rota compartilhada.
              Pacotes de até {SHARED.maxSize} e {SHARED.maxWeight}.
            </p>
          </div>
        </div>
      </section>

      <section className="section-tight bg-ink-50">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="card p-6 lg:p-8">
            <div className="flex items-center gap-2 mb-6">
              <CheckCircleIcon className="h-6 w-6 text-emerald-600" />
              <h2 className="font-display text-xl font-bold text-ink-900">Municípios da rota</h2>
              <span className="ml-auto badge !bg-emerald-100 !text-emerald-700 !border-emerald-200">
                {CITIES.length} cidades
              </span>
            </div>
            <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
              {CITIES.map((nome) => (
                <li key={nome} className="flex items-center gap-3 p-3 rounded-xl hover:bg-ink-50 transition group">
                  <span className="h-8 w-8 rounded-lg bg-brand-gradient text-white flex items-center justify-center shrink-0 shadow-glow">
                    <MapPinIcon className="h-4 w-4" />
                  </span>
                  <span className="font-semibold text-ink-800">{nome}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm text-ink-500">
              Se o endereço estiver na RM e o pacote couber no limite, entra na rota.
              Confirmamos na ativação do plano.
            </p>
            <div className="mt-6 text-center">
              <Link to="/#contato" className="btn-primary">Quero Fretz Empresas</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container mx-auto px-4 lg:px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { value: SHARED.coverage, label: 'Área de rota' },
              { value: SHARED.doorWait, label: 'Espera na porta' },
              { value: '36h / 72h', label: 'SLA conforme o plano' },
              { value: SHARED.fromPrice, label: 'A partir de' },
            ].map(({ value, label }) => (
              <div key={label} className="card p-6 text-center">
                <p className="font-display text-2xl font-extrabold text-brand-700">{value}</p>
                <p className="text-sm text-ink-500 mt-1">{label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default RegioesAtendidas;
